import * as CryptoJS from 'crypto-js';
import { unserializeString } from './unserialize-string';

export function decryptData(data: string, passphrase: string) {
  const encryptionKey = CryptoJS.enc.Utf8.parse(passphrase);
  const payload = JSON.parse(atob(data));

  for (const item of ['iv', 'value', 'mac']) {
    if (!payload[item] || typeof payload[item] !== 'string') {
      throw new Error('The payload is invalid');
    }
  }
  if (atob(payload.iv).length !== 16) {
    throw new Error('The iv is invalid');
  }

  const mac = CryptoJS.HmacSHA256(payload.iv + payload.value, encryptionKey);
  if (mac.toString(CryptoJS.enc.Hex) !== payload.mac) {
    throw new Error('The MAC is invalid');
  }

  const iv = CryptoJS.enc.Base64.parse(payload.iv);
  const decryptedData = CryptoJS.AES.decrypt(payload.value, encryptionKey, { iv });
  const unserialized = unserializeString(decryptedData.toString(CryptoJS.enc.Utf8));
  if (!unserialized) return null;
  return JSON.parse(unserialized, dateReviver);
}

function dateReviver(key: string, value: any): any {
  if (typeof value !== 'string') {
    return value;
  }

  const match = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/.exec(value);
  if (!match) {
    return value;
  }

  return new Date(value);
}
